// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/chatters/v1/session.proto (package gdx.chatters.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";

/**
 * Enumerates dialogue channels.
 *
 * @generated from enum gdx.chatters.v1.Channel
 */
export enum Channel {
  /**
   * @generated from enum value: CHANNEL_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: CHANNEL_FREE = 1;
   */
  FREE = 1,

  /**
   * @generated from enum value: CHANNEL_TRIAL = 2;
   */
  TRIAL = 2,

  /**
   * @generated from enum value: CHANNEL_PREMIUM = 3;
   */
  PREMIUM = 3,

  /**
   * @generated from enum value: CHANNEL_EX_PREMIUM = 4;
   */
  EX_PREMIUM = 4,

  /**
   * @generated from enum value: CHANNEL_EX_TRIAL = 5;
   */
  EX_TRIAL = 5,

  /**
   * @generated from enum value: CHANNEL_NTF = 6;
   */
  NTF = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(Channel)
proto3.util.setEnumType(Channel, "gdx.chatters.v1.Channel", [
  { no: 0, name: "CHANNEL_INVALID" },
  { no: 1, name: "CHANNEL_FREE" },
  { no: 2, name: "CHANNEL_TRIAL" },
  { no: 3, name: "CHANNEL_PREMIUM" },
  { no: 4, name: "CHANNEL_EX_PREMIUM" },
  { no: 5, name: "CHANNEL_EX_TRIAL" },
  { no: 6, name: "CHANNEL_NTF" },
]);

/**
 * Enumerates session statuses.
 *
 * @generated from enum gdx.chatters.v1.Status
 */
export enum Status {
  /**
   * @generated from enum value: STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: STATUS_ON_BREAK = 2;
   */
  ON_BREAK = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(Status)
proto3.util.setEnumType(Status, "gdx.chatters.v1.Status", [
  { no: 0, name: "STATUS_INVALID" },
  { no: 1, name: "STATUS_ACTIVE" },
  { no: 2, name: "STATUS_ON_BREAK" },
]);

/**
 * Describes active chatter session.
 *
 * @generated from message gdx.chatters.v1.Session
 */
export class Session extends Message<Session> {
  /**
   * @generated from field: string team_member_id = 1;
   */
  teamMemberId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: google.protobuf.Timestamp started_time = 3;
   */
  startedTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration started_duration = 4;
   */
  startedDuration?: Duration;

  /**
   * @generated from field: uint64 total_dialogs = 5;
   */
  totalDialogs = protoInt64.zero;

  /**
   * @generated from field: uint64 total_unread_dialogs = 6;
   */
  totalUnreadDialogs = protoInt64.zero;

  /**
   * @generated from field: uint64 total_unanswered_dialogs = 7;
   */
  totalUnansweredDialogs = protoInt64.zero;

  /**
   * @generated from field: uint64 free_messages = 8;
   */
  freeMessages = protoInt64.zero;

  /**
   * @generated from field: uint64 trial_messages = 9;
   */
  trialMessages = protoInt64.zero;

  /**
   * @generated from field: uint64 premium_messages = 10;
   */
  premiumMessages = protoInt64.zero;

  /**
   * @generated from field: uint64 power_like_messages = 11;
   */
  powerLikeMessages = protoInt64.zero;

  /**
   * @generated from field: repeated gdx.chatters.v1.Channel channels = 12;
   */
  channels: Channel[] = [];

  /**
   * @generated from field: repeated string locales = 17;
   */
  locales: string[] = [];

  /**
   * @generated from field: gdx.chatters.v1.Status status = 13;
   */
  status = Status.INVALID;

  /**
   * @generated from field: google.protobuf.Duration total_break_duration = 14;
   */
  totalBreakDuration?: Duration;

  /**
   * @generated from field: float average_velocity = 15;
   */
  averageVelocity = 0;

  /**
   * @generated from field: google.protobuf.Duration current_break_duration = 16;
   */
  currentBreakDuration?: Duration;

  constructor(data?: PartialMessage<Session>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.chatters.v1.Session";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "team_member_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "started_time", kind: "message", T: Timestamp },
    { no: 4, name: "started_duration", kind: "message", T: Duration },
    { no: 5, name: "total_dialogs", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "total_unread_dialogs", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "total_unanswered_dialogs", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "free_messages", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 9, name: "trial_messages", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 10, name: "premium_messages", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 11, name: "power_like_messages", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 12, name: "channels", kind: "enum", T: proto3.getEnumType(Channel), repeated: true },
    { no: 17, name: "locales", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 14, name: "total_break_duration", kind: "message", T: Duration },
    { no: 15, name: "average_velocity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 16, name: "current_break_duration", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Session {
    return new Session().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Session {
    return new Session().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Session {
    return new Session().fromJsonString(jsonString, options);
  }

  static equals(a: Session | PlainMessage<Session> | undefined, b: Session | PlainMessage<Session> | undefined): boolean {
    return proto3.util.equals(Session, a, b);
  }
}

/**
 * Describes chatter channel preset.
 *
 * @generated from message gdx.chatters.v1.SessionChannelPreset
 */
export class SessionChannelPreset extends Message<SessionChannelPreset> {
  /**
   * @generated from field: string team_member_id = 1;
   */
  teamMemberId = "";

  /**
   * @generated from field: string team_member_email = 2;
   */
  teamMemberEmail = "";

  /**
   * @generated from field: repeated gdx.chatters.v1.Channel channels = 3;
   */
  channels: Channel[] = [];

  /**
   * @generated from field: repeated string locales = 4;
   */
  locales: string[] = [];

  constructor(data?: PartialMessage<SessionChannelPreset>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.chatters.v1.SessionChannelPreset";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "team_member_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "team_member_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "channels", kind: "enum", T: proto3.getEnumType(Channel), repeated: true },
    { no: 4, name: "locales", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SessionChannelPreset {
    return new SessionChannelPreset().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SessionChannelPreset {
    return new SessionChannelPreset().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SessionChannelPreset {
    return new SessionChannelPreset().fromJsonString(jsonString, options);
  }

  static equals(a: SessionChannelPreset | PlainMessage<SessionChannelPreset> | undefined, b: SessionChannelPreset | PlainMessage<SessionChannelPreset> | undefined): boolean {
    return proto3.util.equals(SessionChannelPreset, a, b);
  }
}

